import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class OperatingproceduresService {

	 hedr = new HttpHeaders().set('Content-Type', 'application/json');

	constructor(private readonly http : HttpClient) { }

	getDetails(): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/op`, httpCustomOptions)
			.pipe(
				tap(_ => this.log('data success')),
				catchError(this.handleError<any>('data fails'))
			);
  }
  
  addOP(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/op/addOP`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log('data inserted success')),
				catchError(this.handleError<any>('data insert failed'))
			);
	}

	editOP(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/op/updateOP`, arrData)
			.pipe(
				tap(_ => this.log('data inserted success')),
				catchError(this.handleError<any>('data insert failed'))
			);
	}

	deleteOP(arrData: any): Observable<any> {
		return this.http
			.delete(`${environment.baseAPIURL}/api/v1/op/deleteOP/${arrData.opID}`)
			.pipe(
				tap(_ => this.log('data delete success')),
				catchError(this.handleError<any>('data delete failed'))
			);
	}





	private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(message: string) {
		console.info('Message: ' + message);
	}




}

